import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom";
import BotaoVoltar from "./common/botaoVoltar";
import { URL_API } from '../config/urls'
import fetchWithToken from 'config/UseFetchWithToken';

export default function HistoricoPrefeitura() {

	const [dados, setDados] = useState([]);
	let { id } = useParams(0);

	useEffect(() => {

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestAuthorization = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}

		fetchWithToken(`${URL_API}/api/v1/historico/obterPorTabelaEId/TBPREFEITURA/${id}`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					this.resultado = "Erro na leitura dos dados"
				}
				else {
					setDados(res)
				}
			})
			.catch(_err => {
				console.error("Erro interno na aplicação."+_err)
			});
	}, [id])

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-12">
					<header className="main">
						<h2>DISTVAF - Cadastro de Prefeitura - Histórico</h2>
					</header>
				</div>
			</div>
			<div className="row">
				<div className="col-6">
				</div>
				<div className="col-6">
					<BotaoVoltar />
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<div className="table-wrapper margem-antes">
						<table id="tblArquivos" className="table table-hover table-bordered">
							<thead>
								<tr>
									<th>Data</th>
									<th>Alteração</th>
								</tr>
							</thead>
							<tbody>
								{dados.map(result => {
									return (
										<tr className="center" key={result.idHistorico}>
											<td>{result.dataHora}</td>
											<td>Foi alterado o valor do campo <b>{result.campo}</b> de <b>{result.conteudoAnterior}</b> para <b>{result.conteudoNovo}</b> </td>
										</tr>
									);
								})
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	)

}